import SimpleCollapsible from "./SimpleCollapsible";
import GroupConfig from "./Data/GroupConfig";
// import FilterConfig from "./Data/FilterConfig";
import BasicInfo from "./Data/BasicInfo";
import MeasuresSection from "./Data/MeasuresSection";
import ColumnsSelector from "./Data/ColumnsSelector";
import { useContext } from "react";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

const Data = () => {
  const { config } = useContext(GraphConfigFormContext);
  const { t } = useTranslation();

  if (!config) return null;

  return (
    <div className="flex flex-col gap-4 w-full px-4 pt-4 pb-[100px]">
      <BasicInfo configType={config.type} />

      <div className="w-full">
        {config.type === "table" && (
          <SimpleCollapsible
            title={t("editor.graphConfig.data.sections.columns")}
            defaultOpen={true}
          >
            <ColumnsSelector />
          </SimpleCollapsible>
        )}
        {config.type === "graph" && (
          <>
            <SimpleCollapsible
              title={t("editor.graphConfig.data.sections.measures")}
              defaultOpen={true}
            >
              <MeasuresSection />
            </SimpleCollapsible>
          </>
        )}
        {["graph", "table"].includes(config.type) && (
          <SimpleCollapsible
            title={t("editor.graphConfig.data.sections.groupsDimensions")}
            defaultOpen={true}
          >
            <GroupConfig />
          </SimpleCollapsible>
        )}
        {/* <SimpleCollapsible title="Filter" defaultOpen={true}>
          <FilterConfig />
        </SimpleCollapsible> */}
      </div>
    </div>
  );
};

export default Data;
